










































import Vue from 'vue';
export default Vue.extend({
  props: {
    currentCritter: {
      type: Object,
    },
  },
  computed: {
    buyerType(): string {
      if (this.currentCritter.type === 'fish') {
        return 'Cj';
      }
      if (this.currentCritter.type === 'bugs') {
        return 'Flick';
      }
      return '';
    },
  },
});
